export class SlownikRodzajElementu {

  public static readonly POMIESZCZENIE = new SlownikRodzajElementu('POMIESZCZENIE');
  public static readonly ELEWACJA = new SlownikRodzajElementu('ELEWACJA');

  constructor(readonly nazwa: string) {
  }
}
